var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.ObstacleType = {
  WOOD1:0,
  WOOD2:1,
  WOOD3:2,
}

EHDI.game.Obstacle = function () {
    EHDI.aka.Container.call(this);
};

EHDI.game.Obstacle.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Obstacle.prototype.init = function () {
  this._obstacleTexture;
  this._obstacleSprite;

  var random = Math.random();

  if (random < 0.33)
    this._type = EHDI.game.ObstacleType.WOOD1;
  else if (random < 0.66)
    this._type = EHDI.game.ObstacleType.WOOD2;
  else
    this._type = EHDI.game.ObstacleType.WOOD3;

  this._hitbox;

  if (this._hitbox == null) {
    this._hitbox = new EHDI.game.Hitbox(30, 30, 190, 0, 0x0000ff);

    this.addChild(this._hitbox);
  }

  // if (this._obstacleTexture == null) {
    this._obstacleTexture = EHDI.Assets.images[this.getObstacleTexturePath()];
  // }

  if (this._obstacleSprite == null) {
    this._obstacleSprite = new EHDI.aka.Sprite();

    this._obstacleSprite.anchor.x = 0.5;
    this._obstacleSprite.anchor.y = 1;

    this.addChild(this._obstacleSprite);
  }

  this._obstacleSprite.texture = this._obstacleTexture;
};

EHDI.game.Obstacle.prototype.getHitbox = function () {
  return this._hitbox;
};

EHDI.game.Obstacle.prototype.start = function () {
  this.x = 1200;
  this.y = 600;
};

EHDI.game.Obstacle.prototype.getObstacleTexturePath = function () {
  if (this._type == EHDI.game.ObstacleType.WOOD1)
    return 'obstacle';
  else  if (this._type == EHDI.game.ObstacleType.WOOD2)
    return 'obstacle_tree01';
  else
    return 'obstacle_tree02';
};

EHDI.game.Obstacle.prototype.update = function (delta, additionalSpeed) {
  this.x -= additionalSpeed * delta;

  this._hitbox.update(this.x, this.y);
};

EHDI.game.Obstacle.prototype.dispose = function ()
{
  if(this._obstacleSprite != null)
  {
    this.removeChild(this._obstacleSprite);
    this._obstacleSprite.destroy({children: true});
  }
  delete this._obstacleSprite;

  if(this._hitbox != null)
  {
    this._hitbox.dispose();
  }
  delete this._hitbox;
}
